const randomIntFromInterval = (limit: number[]) => {
  return Math.floor(Math.random() * (limit[1] - limit[0] + 1) + limit[0]);
};

let evenWidth = 0;
export const getItemWidth = (index: number, itemsCount: number) => {
  const isEven = index % 2 === 0;
  let oddWidth = 0;
  if (isEven) {
    if (index === itemsCount - 1) {
      return 100 + "%";
    }
    evenWidth = randomIntFromInterval(getSize(2)); // 2 because number of columns will be always 2
    return evenWidth + "%";
  } else {
    oddWidth = 100 - evenWidth;
    return oddWidth + "%";
  }
};

const getSize = (count: number) => {
  if (count < 5) {
    return [47, 53];
  }
  if (count < 8) {
    return [28.33, 38.33];
  }
  return [30.33, 36.33];
};

export const getItemHeight = (itemsCount: number) => {
  if (itemsCount / 5 >= 1) {
    return "33.4%";
  }
  return "50%";
};
